require('../../modules/es.array.find-index');

module.exports = require('../../internals/entry-unbind')('Array', 'findIndex');
